import http from '@/utils/http'
import axios from 'axios'
export function logFindPage(data) {
  return http({
    url: '/bi-api/loginLog/findPage',
    method: 'post',
    data
  })
}
export function collectAnalysisPage(data) {
  return http({
    url: '/bi-api/collectAnalysis/findPage',
    method: 'post',
    data
  })
}
export function collectAnalysisEx({ phone,devUser,provinceCode,cityCode,year,week,month }) {
  return `/bi-api/collectAnalysis/export?provinceCode=${provinceCode}&phone=${phone}&devUser=${devUser}&cityCode=${cityCode}&year=${year}&week=${week}&month=${month}&reqId=${+new Date()}`
}
export function devStatisticsAnalysisFind(data) {
  return http({
    url: '/bi-api/devStatisticsAnalysis/findPage',
    method: 'post',
    data
  })
}

export function sumFindPage(data) {
  return http({
    url: '/bi-api/devSummary/findPage',
    method: 'post',
    data
  })
}
export function monthSumFindPage(data) {
  return http({
    url: '/bi-api/devSummary/month/findPage',
    method: 'post',
    data
  })
}
export function devStatisticsAnalysisEx({ provinceCode,cityCode,year,week,month }) {
  return `/bi-api/devStatisticsAnalysis/export?provinceCode=${provinceCode}&cityCode=${cityCode}&year=${year}&week=${week}&month=${month}&reqId=${+new Date()}`
}
export function devSummaryExp({ provinceCode, year, week, month }) {
  const weekParam = week != null && week !== '' ? `&week=${week}` : ''
  return `/bi-api/devSummary/export?provinceCode=${provinceCode}&year=${year}&month=${month}${weekParam}&reqId=${+new Date()}`
}
export function devSummaryMonthExp({ provinceCode, year, month }) {
  return `/bi-api/devSummary/month/export?provinceCode=${provinceCode}&year=${year}&month=${month}&reqId=${+new Date()}`
}

export function notLoginFindPage(data) {
  return http({
    url: '/bi-api/loginLog/notLoginFindPage',
    method: 'post',
    data
  })
}
export function notLoginFindPageEx({ provinceCode,cityCode,phone,userName,startTime,endTime}) {
  return `/bi-api/loginLog/notLoginExport?provinceCode=${provinceCode}&phone=${phone}&userName=${userName}&cityCode=${cityCode}&startTime=${startTime}&endTime=${endTime}&reqId=${+new Date()}`
}

export function notLoginFindPageEx2({ provinceCode,cityCode,phone,userName,startTime,endTime,reqId}) {
  return `/bi-api/export/notLoginExport?provinceCode=${provinceCode}&phone=${phone}&userName=${userName}&cityCode=${cityCode}&startTime=${startTime}&endTime=${endTime}&reqId=${reqId}`
}



export function collectAnalysisCustomerPage(data) {
  return http({
    url: '/bi-api/customersStat/collectAnalysis/findPage',
    method: 'post',
    data
  })
}
function appendParamsToUrl(url, params) {
  if (!params || typeof params !== 'object') return url;
  const query = Object.keys(params)
      .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
      .join('&');
  if (!query) return url;
  return url + (url.includes('?') ? '&' : '?') + query;
}
export function collectAnalysisCustomerEx({ provinceCode,cityCode,phone,userName,startTime,endTime}) {
  return `/bi-api/customersStat/collectAnalysis/export?provinceCode=${provinceCode}&phone=${phone}&userName=${userName}&cityCode=${cityCode}&startTime=${startTime}&endTime=${endTime}&reqId=${+new Date()}`
}
export function collectAnalysisCustomerEx2({ provinceCode,cityCode,phone,userName,startTime,endTime,reqId}) {
  return `/bi-api/export/collectAnalysis/export?provinceCode=${provinceCode}&phone=${phone}&userName=${userName}&cityCode=${cityCode}&startTime=${startTime}&endTime=${endTime}&reqId=${reqId}`
}
export function operateStatisticsExportScreen(parms) {
  return appendParamsToUrl(`/bi-api/roadOperationStatistics/highway/operateStatisticsExportScreen`, parms)
}
export function nationaloperateStopDetailExportScreen(parms) {
  return appendParamsToUrl(`/bi-api/roadOperationStatistics/national/operateStatisticsExportScreen`, parms)
}
export function operateStopDetailExportScreen(parms) {
  return appendParamsToUrl(`/bi-api/roadOperationStatistics/operateStopDetailExportScreen`, parms)
}

export function operateStatisticsWExportScreen(parms) {
  return appendParamsToUrl(`/bi-api/roadOperationStatisticsW/highway/operateStatisticsWExportScreen`, parms)
}
export function nationaloperateStatisticsWExportScreen(parms) {
  return appendParamsToUrl(`/bi-api/roadOperationStatisticsW/national/operateStatisticsWExportScreen`, parms)
}
export function operateStopDetailExportScreenW(parms) {
  return appendParamsToUrl(`/bi-api/roadOperationStatisticsW/operateStopDetailExportScreen`, parms)
}

export function exportTruckSimplify(parms) {
  return appendParamsToUrl(`/bi-api/truckWuliuV2/exportTruckSimplify`, parms)
}
export function exportTruckWSimplify(parms) {
  return appendParamsToUrl(`/bi-api/truckWuliuV2/exportTruckWSimplify`, parms)
}

export function exportProvinceSimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportProvinceSimplify`, parms)
}

export function exportWayProvinceSimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportWayProvinceSimplify`, parms)
}

export function exportCountySimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportCountySimplify`, parms)
}
export function exportOilStationBerthSimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportOilStationBerthSimplify`, parms)
}

export function exportProvinceWSimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportProvinceWSimplify`, parms)
}
export function exportWayProvinceWSimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportWayProvinceWSimplify`, parms)
}
export function exportCountyWSimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportCountyWSimplify`, parms)
}

export function exportOilStationBerthWSimplify(parms) {
  return appendParamsToUrl(`/bi-api/oilStationBerthCountV2/exportOilStationBerthWSimplify`, parms)
}

export function devStatisticsAnalysisCustomerFind(data) {
  return http({
    url: '/bi-api/customersStat/devStatisticsAnalysis/findPage',
    method: 'post',
    data
  })
}
export function devStatisticsAnalysisCustomerEx({ provinceCode,cityCode,startTime,endTime}) {
  return `/bi-api/customersStat/devStatisticsAnalysis/export?provinceCode=${provinceCode}&cityCode=${cityCode}&startTime=${startTime}&endTime=${endTime}&reqId=${+new Date()}`
}

export function devStatisticsAnalysisCustomerEx2({ provinceCode,cityCode,startTime,endTime,reqId}) {
  return `/bi-api/export/devStatisticsAnalysis/export?provinceCode=${provinceCode}&cityCode=${cityCode}&startTime=${startTime}&endTime=${endTime}&reqId=${reqId}`
}

export function progress({ reqId}) {
  return http({
    url: `/bi-api/export/getProgress?reqId=${reqId}&t=${new Date()*1}`,
    method: 'get'
  })
}
